(function () {
    angular.module('emarket.commons')
    .controller('LargeSliderController', ['$log', 'mdPanelRef', 'images', function ($log, mdPanelRef, images) {
        var vm = this;
        vm.images = images;
        vm.close = function() {
            mdPanelRef.close();
        };
    }]);
}());
